import { render, staticRenderFns } from "./HowFar.vue?vue&type=template&id=047873a4&scoped=true&"
import script from "./HowFar.js?vue&type=script&lang=js&"
export * from "./HowFar.js?vue&type=script&lang=js&"
import style0 from "./HowFar.scss?vue&type=style&index=0&id=047873a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047873a4",
  null
  
)

export default component.exports